@if (logo) {
	<picture class="img">
		<source [srcset]="logo.optimizedSrc" [type]="logo.optimizedType" />
		@if (logo) {
			<img
				[src]="logo.fallbackSrc"
				[alt]="alt"
				[style]="'height: ' + height + '; width: ' + width + ';'"
				[loading]="loading"
				decoding="async"
				onError="this.src='assets/material/no_photo.svg'; this.parentNode.children[0].srcset='assets/material/no_photo.svg';" />
		}
	</picture>
}
